<div
  (click)="galleryService.openGallery($event, attachment.file_uri)"
  [style]="{ width: '250px', height: '200px' }"
  *ngIf="!round && attachment.file_size > allService.maxAutoplaySize; else player"
  class="pointer d-flex flex-column justify-content-center text-center align-items-center"
>
  <i-feather name="play" class="icon-xxl"></i-feather>
  <div class="pt-4"><small>Нажмите для воспроизведения</small></div>
  <!--<div class="mb-2 text-muted text-truncate w-100">
    <small>{{ allService.basename(attachment?.file_uri || '', '') }}</small>
  </div>-->
  <div class="">{{ attachment.file_size_convert }}</div>
</div>

<ng-template #player>
  <div [style]="styles" [class.round]="round" class="position-relative h-100">
    <a *ngIf="mode === 'inline'" (deferLoad)="videoInit()" (click)="toggleMuted($event)" [attr.data-caption]="caption">
      <div *ngIf="!attachment?.file_uri_error" class="timeRemaining">
        <span>{{ timeRemaining | async }} <i-feather *ngIf="isMuted" name="volume-x"></i-feather></span>
      </div>
      <div
        *ngIf="!attachment.file_uri; else videoThumb"
        class="d-flex h-100 flex-column justify-content-center align-items-center"
      >
        <i-feather [name]="attachment?.file_uri_error ? 'alert-octagon' : 'video'" class="icon-xxl"></i-feather>
      </div>

      <ng-template #videoThumb>
        <video [style]="styles" #bunnyVideo *ngIf="attachment.file_uri" loop muted>
          <source (error)="loadVideoError($event)" src="{{ attachment.file_uri }}" [type]="attachment.mime_type" />
        </video>
      </ng-template>
    </a>

    <!--<a *ngIf="mode == 'thumb'">
      <div *ngIf="attachment?.thumb" [style]="styles">
        <a>
          <div *ngIf="!attachment.thumb.file_uri" class="d-flex h-100 flex-column justify-content-center align-items-center">
            <i-feather *ngIf="!attachment.thumb?.file_uri_error; else errorImage" class="icon-xxl" name="image"></i-feather>
          </div>
          <img loading="lazy" (error)="loadImageAttachmentError($event, attachment)" [style]="styles" *ngIf="attachment.thumb.file_uri" class="rounded mb-4 pointer img-fluid w-100 cover" [src]="attachment.thumb.file_uri">
        </a>
      </div>
      <div *ngIf="!attachment.file_uri; else videoThumb" class="d-flex h-100 flex-column justify-content-center align-items-center">
        <i-feather [name]="attachment.file_uri_error ? 'alert-octagon' : 'video'" class="icon-xxl"></i-feather>
      </div>
    </a>-->
  </div>
</ng-template>

<ng-template #errorImage>
  <div tooltip="Ошибка загрузки, нажмите, что бы повторить.">
    <i-feather class="icon-xxl" name="alert-octagon"></i-feather>
  </div>
</ng-template>
